import React from 'react';
import { useSecurity } from '../../../helpers/SecurityHooks';
import { appendScriptsCallback } from '../../../helpers/Utils';

export function GeneralLanguagePage(): React.ReactElement {
  const currentSecurity = useSecurity('General', 'Language');
  React.useEffect(() => {
    if (currentSecurity.checkAccess()) {
      appendScriptsCallback(["Areas/General/Scripts/Resources/en/res.Language.en.js",
        "Areas/General/Scripts/Resources/en/Types.en.js",
        "Areas/General/Scripts/Enums.js",
        "Areas/General/Scripts/Language/Index.js"], "initGeneralLanguage", {});
    }
  }, []);
  return (
    <div className="container-fluid">
      <header className="complete-grid">
        <div id="gridFilter1">
          <div id="gridfilter-toolbar"></div>
        </div>
      </header>
      <section id="gridContainer"></section>
      <ul id="gridContainer-menu"></ul>
    </div>
  );
}
